import React, {useState} from 'react'
import PropTypes from 'prop-types';
import GridBlock from "../../GridBlock";
import {Badge, makeStyles, Tooltip, Typography} from "@material-ui/core";
import Tr from "translations/Translations";
import clsx from 'clsx';
import BoldTypography from "components/BoldTypography";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";
import FilesList from "components/FilesList";
import {Mail, MailOutline, Visibility, VisibilityOff} from '@material-ui/icons';
import MessageEmailDeliveryPopup from "./MessageEmailDeliveryPopup";
import MailIcon from "@material-ui/icons/Mail";
import Chip from "@material-ui/core/Chip";
import TooltipIcon from "../../icon/TooltipIcon";
import CorrespondenceService from "../../../services/CorrespondenceService";
import GetAppIcon from "@material-ui/icons/GetApp";
import WorkableIconButton from "../../button/WorkableIconButton";
import useSalesNotification from "../../../hooks/useSalesNotification";
import SignatureIcon from "../../icon/SignatureIcon";
import salesNotificationKeys from "components/popup/salesNotification/constants/salesNotification.keys";
import contractorNameBuilder from "libs/contractorNameBuilder";
import Alert from "components/popup/alert/Alert";
import {connect} from "react-redux";

const useStyles = makeStyles(theme => ({
    root: {
        width: '80%',
        margin: 5,
    },
    rootMine: {
        marginLeft: '20%'
    },
    recipientsRoot: {
        display: 'flex',
        justifyContent: 'left',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(0.5),
            paddingRight: theme.spacing(1),
        },
    },
    contentWrapper: {
        border: `solid 1px ${theme.palette.primary.main}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
        position: 'relative'
    },
    contentWrapperUnread: {
        borderWidth: 3
    },
    contentWrapperMine: {
        backgroundColor: theme.palette.background.default
    },
    content: {
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
    },
    sendDate: {
        margin: `0 ${theme.spacing(1)}px`,
        minWidth: 110
    },
    message: {
        whiteSpace: 'pre-line',
        margin: `${theme.spacing(2)}px 0`
    },
    newBadge: {
        position: 'absolute',
        right: 0,
        top: 3
    },
}));


function Message(
    {
        rfxRoundId,
        listResourceId,
        contractor,
        message,
        hasEdit,
        downloadAttachmentRegistrationDate
    }) {

    const classes = useStyles();
    const [emailDeliveryRecipient, setEmailDeliveryRecipient] = useState(null);
    const [downloadZipWorking, setDownloadZipWorking] = useState(false);
    const [verificationWorking, setVerificationWorking] = useState(false);
    const mine = !!(contractor ? (message.contractorUser || message.publicQuestion || message.buyerAsContractorUser) : message.buyerUser);
    const unread = !mine && !message.read && !message.buyerAsContractorUser;
    const [showVerifyLimitUsedAlert, setShowVerifyLimitUsedAlert] = useState(false);
    const showAttachmentDownloadInfo = mine && !!downloadAttachmentRegistrationDate && moment(downloadAttachmentRegistrationDate) < moment.now()


    const showEmailDelivery = (recipient) => {
        setEmailDeliveryRecipient(recipient);
    }


    const getSender = () => (message.contractorUser ?  <Tooltip title={`${message.contractorUser.firstName} ${message.contractorUser.lastName}`}><Chip label={message.sender.name}/></Tooltip>  : <Chip label={message.sender.name} />)
    const getRecipient = (recipient) => (

        <Chip key={recipient.id} label={contractorNameBuilder(recipient)} onDelete={()=> {}} deleteIcon={
            <>

                {!contractor && <> {recipient.firstEmailDeliveryDate ?
                    <TooltipIcon onClick={() => showEmailDelivery(recipient)} Icon={Mail} tooltip={`${Tr('message_delivered')}: ${moment(recipient.firstEmailDeliveryDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT)}`}/> :
                    <TooltipIcon onClick={() => showEmailDelivery(recipient)} Icon={MailOutline} tooltip={Tr('message_not_delivered')} label={recipient.name}/>}
                    </>
                }

                {!message.buyerAsContractorUser &&
                <>
                    {!!recipient.firstReadDate ?
                        <TooltipIcon Icon={Visibility} tooltip={`${Tr('message_read')}: ${moment(recipient.firstReadDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT)}`}/>
                        :
                        <TooltipIcon Icon={VisibilityOff} tooltip={Tr('message_unread')}/>}
                </>
                }
            </>
        }/>
    )

    const getStatusCaption = () => {
        if (message.buyerAsContractorUser) {
            return "send_buyer_as_contractor_date";
        } else if (message.published) {
            return "send_and_publish_date";
        } else {
            return "send_date";
        }
    }
    const onPrintVerification = () => {
        setVerificationWorking(true);
        CorrespondenceService.checkVerificationLimit(rfxRoundId, message.messageId).then(resp => {
            if (resp.result)
                CorrespondenceService.printBuyerMessageAttachmentsVerification(rfxRoundId, message.messageId, () => setVerificationWorking(false));
            else {
                setVerificationWorking(false);
                setShowVerifyLimitUsedAlert(true);
            }
        });
    }
    const printVerificationSalesCheck = useSalesNotification(salesNotificationKeys.SIGNATURE_VERIFICATOR, onPrintVerification);

    const onDownloadZip = () => {
        const method = contractor ? CorrespondenceService.downloadContractorMessageAttachmentsZip : CorrespondenceService.downloadBuyerMessageAttachmentsZip;
        setDownloadZipWorking(true);
        method(rfxRoundId, message.messageId, () => setDownloadZipWorking(false));
    }

    const downloadAttachment = (attachment) => {
        const method = contractor ? CorrespondenceService.downloadContractorMessageAttachment : CorrespondenceService.downloadBuyerMessageAttachment;
        method(rfxRoundId, attachment.identity)
    }

    const getCustomAttachmentActions = (attachments) => (
        <>
            {!mine && attachments.some(a => !a.inaccessible) &&
            <WorkableIconButton
                tooltip={Tr('download_all_message_attachments')}
                Icon={GetAppIcon}
                onClick={onDownloadZip}
                working={downloadZipWorking}/>
            }
            {(!contractor && !mine && hasEdit) &&
            <WorkableIconButton
                tooltip={Tr('print_message_attachments_verification')}
                Icon={SignatureIcon}
                onClick={printVerificationSalesCheck}
                working={verificationWorking}/>
            }
        </>
    )

    return (
        <div className={clsx(classes.root, {[classes.rootMine]: mine, 'new-message-scroll-to': unread})}>

            <div className={clsx(classes.contentWrapper, {[classes.contentWrapperMine]: mine, [classes.contentWrapperUnread]: unread})}>
                <div className={classes.content}>
                    {unread && <Badge className={clsx(classes.newBadge)} badgeContent='NOWA' color="error">
                        <MailIcon color='primary'/>
                    </Badge>}
                    <GridBlock justify='flex-end'>
                        <BoldTypography variant='caption'>{`${Tr(getStatusCaption())}: `}</BoldTypography>
                        <Typography variant='caption' component='p' className={classes.sendDate}>
                            {message.sendDate ? moment(message.sendDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT) : ''}
                        </Typography>
                    </GridBlock>

                    <div className={classes.recipientsRoot}>
                        <Typography><strong>{mine ? Tr('recipients') : Tr('sender')}: </strong></Typography>
                        {mine ? message.recipients.map(x => getRecipient(x)) : getSender()}
                    </div>

                    <Typography variant='body1' className={classes.message}>{message.contents}</Typography>

                    {!!message?.attachments?.length && <>
                        <BoldTypography>{Tr('attachment')}</BoldTypography>
                        <FilesList elements={message.attachments} onDownload={downloadAttachment} customAction={getCustomAttachmentActions(message.attachments)}
                                   showDownloadDate={showAttachmentDownloadInfo} />
                    </>}
                </div>
            </div>
            {!!emailDeliveryRecipient && <MessageEmailDeliveryPopup recipient={emailDeliveryRecipient} messageId={message.messageId} rfxRoundId={rfxRoundId}
                                                                    onClose={() => setEmailDeliveryRecipient(null)}/>}
            {showVerifyLimitUsedAlert && <Alert
                confirmText={Tr('client.limit.verification.used')}
                open={showVerifyLimitUsedAlert}
                onClose={() => setShowVerifyLimitUsedAlert(false)}
                maxWidth='sm'
            />}
        </div>
    )
}

Message.propTypes = {
    classes: PropTypes.any,
}

const mapStateToProps = (state) => {
    return {
        downloadAttachmentRegistrationDate: state.resources[CorrespondenceService.CORRESPONDENCE_DOWNLOAD_ATTACHMENT_REGISTRATION_DATE_RESOURCE_ID],
    }
}
const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Message);